module.exports = __webpack_public_path__ + "img/zeigling7.1e2cb9d9.jpg";